const FinancialRisk = {
  // Risk Levels (inchangés)
  riskLevels: [
    { value: 1, label: 'Low Risk', color: '#4CAF50' },
    { value: 2, label: 'Medium-Low Risk', color: '#8BC34A' },
    { value: 3, label: 'Medium Risk', color: '#FFEB3B' },
    { value: 4, label: 'Medium-High Risk', color: '#FFC107' },
    { value: 5, label: 'High Risk', color: '#FF5722' }
  ],

  // Facteurs de risque et leurs critères d'évaluation
  riskFactors: [
    {
      factor: 'countryRisk',
      label: 'Country Risk',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Very stable country with strong economic and political environment', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Stable country with good economic conditions and political stability', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderate country risk with some economic or political challenges', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'High country risk with significant economic or political instability', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very high country risk with severe economic crisis or political turmoil', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'companyAge',
      label: 'Company Age',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Well-established company, over 10 years in operation', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Established company, 5-10 years in operation', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderately established, 3-5 years in operation', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Relatively new company, 1-3 years in operation', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very new company, less than 1 year in operation', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'shippingDeliveryMode',
      label: 'Shipping/Delivery Mode',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Highly reliable shipping with full tracking and insurance', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Reliable shipping with tracking and partial insurance', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Standard shipping with basic tracking', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Less reliable shipping with limited tracking or high loss rates', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Unreliable shipping with no tracking or frequent issues', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'financialStability',
      label: 'Financial Stability',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Strong financial position with consistent profitability and high liquidity', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good financial position with minor fluctuations and adequate liquidity', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Adequate financial position with some volatility and moderate liquidity', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Weak financial position with frequent losses and low liquidity', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very poor financial health, potential bankruptcy risk, severe liquidity issues', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'paymentHistory',
      label: 'Payment History',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Excellent payment history, always on time with occasional early payments', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good payment history, rarely late, no defaults', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Fair payment history, occasionally late but always pays', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Poor payment history, frequently late with occasional minor defaults', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very poor payment history, multiple significant defaults or bankruptcies', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'industryRisk',
      label: 'Industry Risk',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Stable industry with strong growth prospects and low cyclicality', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Relatively stable industry with moderate growth and manageable cyclicality', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Industry with average stability, growth, and moderate cyclicality', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Volatile industry with limited growth prospects and high cyclicality', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Highly unstable industry, declining sector, or extreme cyclicality', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'operationalRisk',
      label: 'Operational Risk',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Robust operational processes with strong controls and risk management', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good operational processes with adequate controls and risk awareness', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Average operational processes with some weaknesses in controls', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Weak operational processes with significant gaps in controls', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very poor operational processes, high risk of failure, minimal controls', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'concentrationRisk',
      label: 'Concentration Risk',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Well-diversified customer and supplier base across multiple sectors', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good diversification with minor concentration in customers or suppliers', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderate concentration in customers or suppliers within related sectors', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'High concentration in customers or suppliers in a single sector', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Extreme concentration, dependent on very few entities in one sector', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'managementQuality',
      label: 'Management Quality',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Highly experienced management with strong track record and succession planning', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Experienced management with good track record and some succession planning', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Adequate management experience with moderate track record', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Limited management experience or questionable track record', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Inexperienced management, poor track record, or frequent turnover', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'marketPosition',
      label: 'Market Position',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Market leader with strong competitive advantages and brand recognition', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Strong market position with some competitive advantages', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Average market position with few distinct competitive advantages', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Weak market position, struggling to compete effectively', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very weak market position, losing market share rapidly', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'regulatoryEnvironment',
      label: 'Regulatory Environment',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Favorable regulatory environment with minimal impact on operations', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Stable regulatory environment with manageable impact on operations', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Evolving regulatory environment requiring ongoing adaptations', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Challenging regulatory environment with significant impact on operations', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Hostile regulatory environment threatening business viability', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'financialTransparency',
      label: 'Financial Transparency',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Full transparency with audited financials and detailed reporting', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good transparency with regular reporting and some external validation', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Adequate transparency with basic reporting but limited detail', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Poor transparency with inconsistent or limited financial disclosure', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very poor transparency, unwilling to share financial information', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'businessContinuity',
      label: 'Business Continuity',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Robust continuity plans, regularly tested and updated', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good continuity plans in place, occasionally tested', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Basic continuity plans exist but not regularly updated or tested', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Limited or outdated continuity plans', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'No business continuity plans in place', description: 'Very High Risk' }
      ]
    },
    {
      factor: 'financingCriteria',
      label: 'Financing Criteria for Investors',
      criteria: [
        { value: 1, label: 'A', color: '#4CAF50', rationale: 'Excellent financial health, high liquidity, low risk of default', description: 'Very Low Risk' },
        { value: 2, label: 'B', color: '#8BC34A', rationale: 'Good financial health, adequate liquidity, low to moderate risk of default', description: 'Low Risk' },
        { value: 3, label: 'C', color: '#FFEB3B', rationale: 'Moderate financial health, moderate liquidity, moderate risk of default', description: 'Moderate Risk' },
        { value: 4, label: 'D', color: '#FFC107', rationale: 'Weak financial health, low liquidity, high risk of default', description: 'High Risk' },
        { value: 5, label: 'E', color: '#FF5722', rationale: 'Very poor financial health, very low liquidity, very high risk of default', description: 'Very High Risk' }
      ]
    }
  ],

  // Fonctions inchangées
  calculateOverallRisk: (scores) => {
    const totalScore = Object.values(scores).reduce((sum, score) => sum + score, 0);
    const averageScore = totalScore / Object.keys(scores).length;
    return Math.round(averageScore);
  },

  getRiskLevel: (score) => {
    return FinancialRisk.riskLevels.find(level => level.value === score);
  },

  evaluateBuyer: (buyerScores) => {
    const overallScore = FinancialRisk.calculateOverallRisk(buyerScores);
    const riskLevel = FinancialRisk.getRiskLevel(overallScore);
    return {
      scores: buyerScores,
      overallScore,
      riskLevel
    };
  }
};

export default FinancialRisk;
